// extracted by mini-css-extract-plugin
export var feed__item = "Feed-module--feed__item--YZyhu";
export var feed__item_description = "Feed-module--feed__item_description--gX2IH";
export var feed__item_meta_category_link = "Feed-module--feed__item_meta_category_link--wAxaE";
export var feed__item_meta_divider = "Feed-module--feed__item_meta_divider--s2YVx";
export var feed__item_meta_time = "Feed-module--feed__item_meta_time--cKehM";
export var feed__item_readmore = "Feed-module--feed__item_readmore--w+7xP";
export var feed__item_title = "Feed-module--feed__item_title--mPLOi";
export var feed__item_title_link = "Feed-module--feed__item_title_link--ljbOE";